<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
export default {
  name: 'LineChart',
  extends: Line,
  mixins: [reactiveProp],
  props: {
    legend: { type: Boolean, default: true },
    options: {
      type: Object,
      default: () => {
        return {
          annotation: {
            annotations: [
              {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-0',
                value: '26',
                borderColor: 'tomato',
                borderWidth: 1,
              },
            ],
            drawTime: 'afterDraw', // (default)
          },
          animation: {
            duration: 1,
          },
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            labels: {
              boxWidth: 10,
              boxHeight: 10,
              usePointStyle: true,
            },
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  stepSize: 5,
                },
              },
            ],
          },
        }
      },
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}
</script>
